import React from 'react'
import {AppointmentSetting , ButtonComponent} from 'tutorapp-components'
import { useNavigate } from 'react-router-dom'


export default function AppointmentSettingScreen() {

  const navigate = useNavigate()

  const onarrowclick = () => {
    navigate("/editAppointment")
  }
  const ondelete = () => {
    console.log('deleteclick')
  }
  const icons = {
    backarrow: "./images/ic_back.svg",
    address: "./images/ic_tutoring_address.svg",
    repeat: "./images/ic_repeat.svg",
  };

  return (
    <div>

      <AppointmentSetting onarrowclick={onarrowclick} icons={icons} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: '55px' }}>
        <div style={{ width: "360px", marginBottom: 10 }}>
          <ButtonComponent
            label="Save"
            style={{ backgroundColor: "#000", paddingVertical: 12 }}
            textStyle={{ color: "#fff" }}
          />
        </div>

        <div style={{ width: "360px" }}>
          <ButtonComponent
            label="Cancel"
            onPress={() => console.log("Button Pressed")}
            style={{ backgroundColor: "#fff", paddingVertical: 12 }}
            textStyle={{ color: "#000" }}
          />
        </div>
      </div>

    </div>
  )
}
